var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lad-avatar"},[_c('div',{staticClass:"el-avatar el-avatar--circle",class:[`el-avatar--size-${_vm.size}`, _vm.svgClass]},[_c('LadImage',{staticClass:"image--cover",attrs:{"src":_vm.src,"srcset":_vm.srcSet}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }